"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultFormatDate = exports.formatDateUTC = exports.formatInTimeZone = exports.getStartAndEndTime = void 0;
const date_fns_1 = require("date-fns");
const date_fns_tz_1 = require("date-fns-tz");
const getStartAndEndTime = (startProps, endProps) => {
    let start_at = null;
    let end_at = null;
    let days = 0;
    try {
        if (startProps) {
            start_at = (0, exports.formatDateUTC)(String(startProps));
        }
        if (endProps) {
            end_at = (0, exports.formatDateUTC)(String(endProps));
        }
        if (start_at && end_at) {
            days = (0, date_fns_1.differenceInDays)(end_at, start_at) + 1;
        }
        return {
            startAt: start_at,
            endAt: end_at,
            days: days,
        };
    }
    catch {
        return {
            startAt: start_at,
            endAt: end_at,
            days: days,
        };
    }
};
exports.getStartAndEndTime = getStartAndEndTime;
const formatInTimeZone = (date, fmt = 'yyyy-MM-dd kk:mm:ss xxx', tz = 'UTC') => (0, date_fns_tz_1.format)((0, date_fns_tz_1.utcToZonedTime)(date, tz), fmt, { timeZone: tz });
exports.formatInTimeZone = formatInTimeZone;
const formatDateUTC = (date) => {
    try {
        let localDate = date;
        if (typeof date === 'object') {
            return null;
        }
        if (typeof date === 'string') {
            localDate = new Date(date);
        }
        const day = String(localDate.getUTCDate()).padStart(2, '0');
        const month = localDate
            .toLocaleString('en-GB', { month: 'numeric', timeZone: 'UTC' })
            .padStart(2, '0');
        const year = localDate.getFullYear();
        return new Date(`${year}-${month}-${day}T00:00:00`);
    }
    catch (e) {
        return new Date();
    }
};
exports.formatDateUTC = formatDateUTC;
const getDefaultFormatDate = (date) => {
    try {
        let localDate = date;
        if (typeof date === 'string') {
            localDate = new Date(date);
        }
        return (0, date_fns_tz_1.format)(localDate, 'yyyy-MM-dd');
    }
    catch {
        return '';
    }
};
exports.getDefaultFormatDate = getDefaultFormatDate;
//# sourceMappingURL=dates.js.map